import React, { useRef } from "react";
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { Button } from 'primereact/button';
import { useEffect, useState } from 'react';
import { SERVER_HOST } from '../settings';

const loadUserProfileHistory = (userId) => {
    const url = `${SERVER_HOST}/users/profileHistory/${userId}`;
    const options = {
    };
    return fetch(url, options).then(data => data.json());
}

export default function PlayerProfileHistory({geoGuessrProfile, playerId}) {

    const [playerProfileHistory, setPlayerProfileHistory] = useState([]);
    const [showAllProfiles, setShowAllProfiles] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        loadUserProfileHistory(playerId).then(data => {
            setPlayerProfileHistory(data);
        })
    }, [playerId]);

    const stepperRef = useRef(null);
    const renderFlag = (countryCode) => {
        return (
            <img src={`../flags/${countryCode}.png`} style={{ width: '24px' }} />
        );
    }
    
    // TODO: do it better one day
    useEffect(() => {
        setTimeout(() => {
            var biggerThanMobile = window.matchMedia("(min-width: 768px)");
            const newIsMobile = !biggerThanMobile.matches;
            setIsMobile(newIsMobile);
            setShowAllProfiles(newIsMobile);
        }, 0);
    }, [])

    const renderStepper = (profile, isFirst, isLast) => {
        if (!profile) {
            return;
        }

        if (profile.isDummy) {
            return (
                <StepperPanel header="More...">
                
                <div className={`flex pt-4 justify-content-center`}>
                    <Button label="Load more profile history" severity="primary" icon="pi pi-arrow-down" onClick={() => setShowAllProfiles(true)} />
                </div>
            </StepperPanel>
            )
        }

        const backButton = (isFirst) => {
            if (isFirst) {
                return;
            }
            return <Button label="Back" severity="secondary" icon="pi pi-arrow-left" onClick={() => stepperRef.current.prevCallback()} />;
        }
        const nextButton = (isLast) => {
            if (isLast) {
                return;
            }
            return <Button label="Next" icon="pi pi-arrow-right" iconPos="right" onClick={() => stepperRef.current.nextCallback()} />;
        }
        const justifyContentClass = (isFirst, isLast) => {
            if (isFirst) {
                return 'justify-content-end';
            }
            if (isLast) {
                return 'justify-content-start';
            }
            return 'justify-content-between';
        }

        return (
            <StepperPanel header={`${new Date(profile.batchDate).toLocaleDateString()}`}>
                {isMobile ? <div className=" flex-column h-12rem player-history-compact">
                    <div className="flex-column">
                        <div className="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium ">
                        <div class="grid nested-grid">
                            <div class="col-4">
                                <div class="grid">
                                    <div class="col-12">
                                        <div class="text-center p-1 border-round-sm">
                                            <img src={`https://www.geoguessr.com/images/resize:auto:300:300/gravity:ce/plain/pin/${profile.fullBodyPath}.png`} style={{width: '100%'}}/>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="text-center p-1 border-round-sm">
                                            <img src={`https://www.geoguessr.com/images/resize:auto:300:300/gravity:ce/plain/pin/${profile.avatar}.png`} style={{width: '100%'}}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-8">
                                <div class="text-center p-3 border-round-sm h-full">
                                    <h2>{profile.nick} &nbsp;<br /><br />{renderFlag(profile.countryCode)}&nbsp; {profile.countryName}</h2>
                                </div>
                            </div>
                        </div>
                        </div>

                    </div>
                </div> : 
                <div className=" flex-column h-12rem player-history-normal">
                    <div className="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium">
                        <img src={`https://www.geoguessr.com/images/resize:auto:300:300/gravity:ce/plain/pin/${profile.avatar}.png`} style={{ position: 'absolute', 'marginLeft': 'calc(50rem - 240px)', height: '160px' }}/>
                        <img src={`https://www.geoguessr.com/images/resize:auto:300:300/gravity:ce/plain/pin/${profile.fullBodyPath}.png`} style={{ 'marginLeft': '-15rem', height: '180px' }}/>
                        <span style={{width: '25rem'}}>{profile.nick} &nbsp;<br /><br />{renderFlag(profile.countryCode)}&nbsp; {profile.countryName}</span>
                    </div>
                </div> }
                <div className={`flex pt-4 ${justifyContentClass(isFirst, isLast)}`}>
                    {backButton(isFirst)}
                    {nextButton(isLast)}
                </div>
            </StepperPanel>
        )
    }
    console.log('geoGuessrProfile', isMobile)
    const allProfiles = geoGuessrProfile ? [geoGuessrProfile] : playerProfileHistory;
    
    const sliceProfiles = (profiles) => {
        const maxNoOfProfiles = 4;
        if (!profiles || profiles.length <= maxNoOfProfiles) {
            return profiles;
        }
        const slicedProfiles = profiles.slice(0, maxNoOfProfiles);
        const dummyProfileToShowAllProfiles = {isDummy: true};
        return [...slicedProfiles, dummyProfileToShowAllProfiles];
    };
    
    const profiles = showAllProfiles ? allProfiles : sliceProfiles(allProfiles);

    const steppers = profiles?.map((profile, index) => renderStepper(profile, index === 0, index === profiles?.length - 1));
    
    return (
    <div className="card  justify-content-center">
        <Stepper ref={stepperRef} style={{ flexBasis: '50rem' }} orientation={(steppers?.length > 5 || isMobile) ? 'vertical' : 'horizontal'}>
            {steppers}
        </Stepper>
    </div>
    )
}
        